export default {
	title: 'Navigation Item',
};
